<template>
  <div class="boxbgcolor">
    <div class="content-left">
      <AllTree ref="areaTree" :moduleName="moduleName" v-on:handleTreeClick="handleTreeClick"></AllTree>
    </div>
    <div class="right content-right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">名称</label>
            <input
              v-model="search.name"
              class="form-control"
              v-noBlankSpace
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <span class="add_btn">
              <button type="button" class="btn btn-default" id="add" @click="addOrEdit()">添加</button>
            </span>
            <!-- <span class="download_btn"><ExportExcel v-bind:tableListData="this.tableListData" v-bind:tableListDataAll="this.tableListDataAll" v-bind:downloadFileds="this.downloadFileds"></ExportExcel></span> -->
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>

      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column show-overflow-tooltip label="名称" prop="name"></el-table-column>
          <el-table-column show-overflow-tooltip label="联系人" prop="contact"></el-table-column>
          <el-table-column show-overflow-tooltip label="联系电话" prop="mobile"></el-table-column>
          <el-table-column show-overflow-tooltip label="地址" prop="address"></el-table-column>
          <el-table-column show-overflow-tooltip label="创建人" prop="crtUserName"></el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template slot-scope="scope">
              <button class="edit" type="button" @click="addOrEdit(scope.row.id)">修改</button>
              <button class="delete" type="button" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>

    <!-- 添加/修改 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="添加/修改"
      :visible.sync="dialogFormVisible"
      width="500px"
      @open="openDialog"
      @close="closeDialog"
    >
      <div class="clearfix">
        <el-form
          class="fl"
          style="width:100%;"
          ref="form"
          label-position="right"
          :model="form"
          :rules="rules"
          :label-width="formLabelWidth"
          id="form"
        >
          <el-form-item label="名称" prop="name">
            <el-col :span="18">
              <el-input v-model="form.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-col :span="18">
              <el-input v-model="form.mobile"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-col :span="18">
              <el-input v-model="form.contact"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-col :span="18">
              <el-input v-model="form.address"></el-input>
            </el-col>
          </el-form-item>
        </el-form>

        <!-- <div class="fr" id="areaMap" style="width: 52%;height: 380px;">
					
        </div>-->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  deleteGroup,
  groupList,
  oneGroup,
  updateOneGroup,
  removeStation,
} from "@/api/url";

import Page from "../../commons/page.vue";

import ExportExcel from "../../commons/exportExcel.vue";

import Refresh from "../../commons/refresh.vue";

import AllTree from "../../commons/allTree";
export default {
  name:'property',
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        parentId: "",
      },
      moduleName: "property",
      type: "property",
      form: {
        id: "",
        name: "",
        mobile: "",
        address: "",
        contact: "",
        // crtUserName:'',
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
      },
      tableListData: [],
      tableListDataTitle: [],
      tableListDataExcel: {},
      formLabelWidth: "100px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        contact: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        mobile: [{ required: true, message: "请填写电话", trigger: "blur" }],
        address: [{ required: true, message: "请填写地址", trigger: "blur" }],
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parentId) {
        this.$message({
          type: "warning",
          message: "请选择集团",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    handleTreeClick(node, data) {
    
      this.search.name = "";
      if (node.type != "group") {
        this.treeData.parentId = "";
        var pageObj = {
          curIndex: 1,
          rowsCount: 0,
        };
       // this.getPage(pageObj);
       this.pageObj={...pageObj}
        this.tableListData = [];
        // this.$message({
        // 	message: '请选择集团',
        // 	type: 'warning'
        // });
        return;
      } else {
        this.treeData.parentId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
    },
    tableList: function (curPage) {
      var _this = this;
      this.$get(groupList(), {
        limit: this.search.pageSize,
        page: curPage,
        type: this.type,
        parentId: this.treeData.parentId,
        name: this.search.name,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        // _this.getPage(pageObj);
        this.pageObj={...pageObj}
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
      if (!this.treeData.parentId) {
        this.$message({
          type: "warning",
          message: "请选择集团",
        });
        return;
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },
    addOrEdit: function (id) {
      this.form.id = id;
      this.dialogFormVisible = true;
      if (Boolean(id)) {
        this.$postRequest(oneGroup(), {
          id: id,
        }).then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          this.form.name = data.data.name;
          this.form.mobile = data.data.mobile;
          this.form.address = data.data.address;
          this.form.contact = data.data.contact;
          // this.form.crtUserName=data.data.crtUserName;
        });
      } else {
        if (!this.treeData.parentId) {
          this.$message({
            type: "warning",
            message: "请选择集团",
          });
          this.dialogFormVisible = false;
          return;
        }

        this.form.name = "";
        this.form.mobile = "";
        this.form.address = "";
        this.form.contact = "";
        // this.form.crtUserName='';
      }
    },
    addOrEditTrue: function () {
      var _this = this;
      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!Boolean(_this.form.id)) {
            _this
              .$postRequest(updateOneGroup(), {
                name: _this.form.name,
                mobile: _this.form.mobile,
                type: _this.type,
                address: _this.form.address,
                parentId: _this.treeData.parentId,
                contact: _this.form.contact,
                // crtUserName:this.form.crtUserName,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功",
                  title: "成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(updateOneGroup() + "/" + _this.form.id, {
                id: _this.form.id,
                type: _this.type,
                name: _this.form.name,
                mobile: _this.form.mobile,
                address: _this.form.address,
                parentId: _this.treeData.parentId,
                contact: _this.form.contact,
                // crtUserName:this.form.crtUserName,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功",
                  title: "成功",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    //   del: function(id) {
    //     var _this = this;

    //     var index = _this.$layer.confirm(
    //       "确定删除？",
    //       {
    //         btn: ["确定", "取消"],
    //         shade: false,
    //         type: 0
    //       },
    //       function() {
    //         _this.$layer.close(index);
    //         _this.$deleteRequest(deleteGroup() + "/" + id, {}).then(data => {
    //           if (data.status != 200)
    //             return _this.$layer.msg("删除失败", { time: 1 });
    //           _this.$notify({
    //             type: "success",
    //             message: "删除成功",
    //             title: "成功"
    //           });
    //           _this.tableList(_this.curIndex);
    //         });
    //       }
    //     );
    //   }
    // },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this.$deleteRequest(deleteGroup() + "/" + id, {}).then((data) => {
            if (data.status == 200) {
              _this.$notify({
                type: "success",
                message: "删除成功",
                title: "成功",
              });
              _this.tableList(_this.pageObj.curIndex);
            } else {
              data.status == -232;
              _this.$notify.error({
                message: "该物业下有车场，请先删除车场！",
                title: "失败",
              });
            }
          });
        }
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    // permiss(){
    // 	this.stationManger_btn_add = this.elements['stationManger:btn_add'];
    // 	this.stationManger_btn_remove = this.elements['stationManger:btn_remove'];
    // 	this.stationManger_btn_edit = this.elements['stationManger:btn_edit'];
    // 	this.stationManger_btn_heart = this.elements['stationManger:btn_heart'];

    // }
  },
  components: {
    Page,
    ExportExcel,
    Refresh,
    AllTree,
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    // this.search.pageNumber=1
    // this.tableList(this.search.pageNumber);
  },
  destroyed: function () {},
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
.delete,
.chargingRules {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
} */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  margin-left: -5%;
  border-radius: 1px;
}
</style>